/**
 * Standard key values matching KeyboardEvent.key for keyboard shortcuts and navigation.
 */
export enum ShortcutKey {
	SLASH = '/',
	QUESTION_MARK = '?',
	ARROW_DOWN = 'ArrowDown',
	ARROW_UP = 'ArrowUp',
	ENTER = 'Enter',
	SPACE = ' ',
	ESCAPE = 'Escape',
	TAB = 'Tab'
}

/**
 * Standard physical key code values matching KeyboardEvent.code for layout-independent shortcut handling.
 */
export enum ShortcutCode {
	SLASH = 'Slash',
	ARROW_DOWN = 'ArrowDown',
	ARROW_UP = 'ArrowUp',
	ENTER = 'Enter',
	NUMPAD_ENTER = 'NumpadEnter',
	SPACE = 'Space',
	ESCAPE = 'Escape',
	TAB = 'Tab'
}
